import React from "react";
import { useParams } from "react-router-dom";

import schools from "./assets/data/schools";

import MetaInfo from "./components/MetaInfo";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Banner from "./course-components/Banner";
import Overview from "./course-components/Overview";
import Subjects from "./course-components/Subjects";
import WhyChoose from "./course-components/WhyChoose";
import Highlights from "./course-components/Highlights";
import Eligibility from "./course-components/Eligibility";
import Structure from "./course-components/Structure";

import campusHero from "./course-details-assets/campus-hero.jpeg";
import classroomImage from "./course-details-assets/classroom.png";
import laboratoryImage from "./course-details-assets/laboratory.png";
import libraryImage from "./course-details-assets/library.png";
import seminarImage from "./course-details-assets/seminar-hall.png";
import studentLifeImage from "./course-details-assets/student-life.png";

import Specialisations from "./course-components/Specialisations";
import Skills from "./course-components/Skills";
import Outcomes from "./course-components/Outcomes";
import Careers from "./course-components/Careers";
import Placement from "./course-components/Placement";
import HigherStudies from "./course-components/HigherStudies";
import AdmissionProcess from "./course-components/AdmissionProcess";
import Faqs from "./course-components/Faqs";
import RelatedPrograms from "./course-components/RelatedPrograms";

import { Label, Title } from "./components/CommonComponents";
import Fees from "./course-components/Fees";

const images = {
  hero: campusHero,
  classroom: classroomImage,
  laboratory: laboratoryImage,
  library: libraryImage,
  seminar: seminarImage,
  studentLife: studentLifeImage,
};

const demoCourse = {
  title: "Master of Business Administration",
  shortName: "MBA",
  school: "School of Management",
  level: "Postgraduate",
  duration: "2 Years",
  mode: "Full Time",
  intake: "2026",
  images: {
    hero: campusHero,
    classroom: classroomImage,
    laboratory: laboratoryImage,
    library: libraryImage,
    seminar: seminarImage,
    studentLife: studentLifeImage,
  },
  overview:
    "The MBA programme builds strategic perspective, managerial confidence and practical business capability through contemporary coursework, case-led learning and industry engagement.",
  eligibility:
    "A recognised bachelor’s degree in any discipline with eligibility determined according to current University admission norms.",
  highlights: [
    [
      "Case-led learning",
      "Analyse business situations and defend decisions using evidence.",
    ],
    [
      "Industry exposure",
      "Learn through expert sessions, live briefs and professional interaction.",
    ],
    [
      "Applied projects",
      "Translate management concepts into measurable organisational solutions.",
    ],
    [
      "Career preparation",
      "Strengthen aptitude, communication, interviews and professional presence.",
    ],
    [
      "Applied projects",
      "Translate management concepts into measurable organisational solutions.",
    ],
    [
      "Career preparation",
      "Strengthen aptitude, communication, interviews and professional presence.",
    ],
  ],
  reasons: [
    "A curriculum connecting management foundations with emerging business practice.",
    "Faculty-guided learning through cases, simulations, presentations and projects.",
    "Opportunities to develop leadership, analytical judgement and enterprise thinking.",
    "Structured career assistance and exposure to contemporary professional expectations.",
  ],
  programStructure: [
    { title: "Semester 1", credits: "24", marks: "600" },
    { title: "Semester 2", credits: "24", marks: "600" },
    { title: "Semester 3", credits: "24", marks: "600" },
    { title: "Semester 4", credits: "24", marks: "600" },
    { title: "Grand Total", credits: "96", marks: "2400" },
  ],
  curriculum: [
    {
      title: "Semester 1",
      subjects: [
        [
          "Management Principles & Organisational Behaviour",
          "MBA101",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        ["Managerial Economics", "MBA102", "4", "20", "10", "70", "-", "100"],
        [
          "Accounting for Managers",
          "MBA103",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Business Communication",
          "MBA104",
          "4",
          "20",
          "10",
          "50",
          "20",
          "100",
        ],
        [
          "Quantitative Techniques",
          "MBA105",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        ["Business Environment", "MBA106", "4", "20", "10", "70", "-", "100"],
      ],
    },
    {
      title: "Semester 2",
      subjects: [
        ["Marketing Management", "MBA201", "4", "20", "10", "70", "-", "100"],
        ["Financial Management", "MBA202", "4", "20", "10", "70", "-", "100"],
        [
          "Human Resource Management",
          "MBA203",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        ["Operations Management", "MBA204", "4", "20", "10", "70", "-", "100"],
        [
          "Business Research Methods",
          "MBA205",
          "4",
          "20",
          "10",
          "50",
          "20",
          "100",
        ],
        [
          "Management Information Systems",
          "MBA206",
          "4",
          "20",
          "10",
          "50",
          "20",
          "100",
        ],
      ],
    },
    {
      title: "Semester 3",
      subjects: [
        ["Strategic Management", "MBA301", "4", "20", "10", "70", "-", "100"],
        ["Business Analytics", "MBA302", "4", "20", "10", "50", "20", "100"],
        [
          "Specialisation Elective I",
          "MBA3E1",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective II",
          "MBA3E2",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective III",
          "MBA3E3",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Summer Internship Project",
          "MBA306",
          "4",
          "20",
          "10",
          "-",
          "70",
          "100",
        ],
      ],
    },
    {
      title: "Semester 4",
      subjects: [
        [
          "Entrepreneurship & Innovation",
          "MBA401",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Business Ethics & Corporate Governance",
          "MBA402",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective IV",
          "MBA4E1",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective V",
          "MBA4E2",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective VI",
          "MBA4E3",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Dissertation / Capstone Project",
          "MBA406",
          "4",
          "20",
          "10",
          "-",
          "70",
          "100",
        ],
      ],
    },
  ],
  specializations: [
    {
      title: "Software & Application Development",
      description:
        "Build deeper capabilities in programming, application development and modern software technologies.",
      focus: "Development",
    },
    {
      title: "Data & Analytics",
      description:
        "Develop analytical thinking and learn how data supports intelligent business and technology decisions.",
      focus: "Analytics",
    },
    {
      title: "Cloud & Digital Infrastructure",
      description:
        "Explore contemporary networks, cloud environments and the digital infrastructure powering modern organisations.",
      focus: "Infrastructure",
    },
  ],
  skills: ["Strategic thinking", "Financial reasoning", "Market analysis", "Team leadership", "Business communication", "Data-informed decisions"],
  outcomes: [
    ["Business judgement", "Evaluate complex organisational situations and recommend responsible action."],
    ["Leadership", "Lead diverse teams with clarity, accountability and professional confidence."],
    ["Analytical capability", "Interpret business evidence and communicate defensible conclusions."],
    ["Enterprise mindset", "Recognise opportunities and develop practical, value-creating responses."],
    ["Apply Knowledge", "Use programme concepts and principles confidently in practical and professional contexts."],
    ["Analyse & Solve", "Evaluate challenges, interpret information and develop logical solutions."],
    ["Work with Professional Tools", "Use relevant technologies, methods and practices associated with the discipline."],
  ],
  careers: [
    "Management Consultant",
    "Business Analyst",
    "Marketing Manager",
    "Financial Analyst",
    "HR Manager",
    "Operations Manager",
    "Entrepreneur",
    "Product Manager",
  ],
  higherStudies: [
    "Ph.D. in Management",
    "Executive education",
    "Professional finance certifications",
    "Business analytics certifications",
  ],
  related: [
    "BBA",
    "B.Com",
    "MBA in Hospital Administration",
    "MBA in Logistics & Supply Chain",
  ],
  placementSupport: [
    {
      number: "01",
      title: "Career Counselling",
      description:
        "Guidance to help students understand career directions, professional interests and opportunities relevant to their programme.",
    },
    {
      number: "02",
      title: "Skill Development",
      description:
        "Focused activities designed to strengthen communication, aptitude, professional behaviour and workplace readiness.",
    },
    {
      number: "03",
      title: "Resume & Profile Building",
      description:
        "Support for presenting academic achievements, projects, skills and experience through a professional career profile.",
    },
    {
      number: "04",
      title: "Interview Preparation",
      description:
        "Practice-oriented preparation through interview guidance, mock interactions and professional communication development.",
    },
    {
      number: "05",
      title: "Employer Engagement",
      description:
        "Opportunities to connect with organisations through placement activities and employer interactions, subject to eligibility.",
    },
  ],
  higherStudies: [
    {
      degree: "Master's Programme",
      field: "Advanced Study",
      description:
        "Progress towards postgraduate education in the same or a closely related academic discipline.",
    },
    {
      degree: "Specialised Master's",
      field: "Specialisation",
      description:
        "Build deeper expertise by pursuing postgraduate study in a specialised area related to the programme.",
    },
    {
      degree: "MBA / Management Studies",
      field: "Management",
      description:
        "Combine your domain knowledge with management, leadership and business-oriented education.",
    },
    {
      degree: "Professional Certification",
      field: "Professional Learning",
      description:
        "Develop additional capabilities through recognised certifications relevant to your chosen career direction.",
    },
    {
      degree: "Research Pathway",
      field: "Research",
      description:
        "Explore research-oriented postgraduate opportunities that can lead towards advanced academic study.",
    },
  ],
  relatedPrograms: [
    {
      title: "Bachelor of Computer Applications",
      level: "Undergraduate",
      duration: "3 Years",
      school: "School of Science",
      href: "/course/bca",
    },
    {
      title: "B.Sc. in Information Technology",
      level: "Undergraduate",
      duration: "3 Years",
      school: "School of Science",
      href: "/course/bsc-it",
    },
    {
      title: "Master of Computer Applications",
      level: "Postgraduate",
      duration: "2 Years",
      school: "School of Science",
      href: "/course/mca",
    },
    {
      title: "M.Sc. in Information Technology",
      level: "Postgraduate",
      duration: "2 Years",
      school: "School of Science",
      href: "/course/msc-it",
    },
  ],
  faqs: [
    {
      question: "Who can apply for this programme?",
      answer:
        "Applicants should satisfy the eligibility requirements prescribed for the programme.",
    },
    {
      question: "What is the duration of the programme?",
      answer:
        "Refer to the programme overview for the applicable duration and academic structure.",
    },
    {
      question: "Does the programme include practical learning?",
      answer:
        "Depending on the programme, learning may include projects, practical sessions, workshops, laboratory work or field exposure.",
    },
    {
      question: "What can I do after completing this programme?",
      answer:
        "Graduates may explore relevant careers, postgraduate study and specialised professional pathways.",
    },
    {
      question: "Does ISBM University provide placement assistance?",
      answer:
        "Career support may include guidance, skill development, interview preparation and employer engagement.",
    },
    {
      question: "How can I get help before applying?",
      answer:
        "Prospective students can connect with the admissions team for programme and application guidance.",
    },
  ],
  admissionProcess: [
    {
      title: "Explore the Programme",
      description:
        "Review programme information, curriculum and eligibility requirements.",
    },
    {
      title: "Check Eligibility",
      description:
        "Confirm that you meet the prescribed programme eligibility criteria.",
    },
    {
      title: "Submit Application",
      description:
        "Complete the University application form with the required information.",
    },
    {
      title: "Upload Documents",
      description: "Provide the required academic and supporting documents.",
    },
    {
      title: "Admission Review",
      description:
        "Your application is reviewed according to the admission procedure.",
    },
    {
      title: "Complete Admission",
      description: "Complete applicable admission formalities and fee payment.",
    },
  ],
  careers: [
    {
      role: "Software Developer",
      area: "Technology",
      description:
        "Design, develop and maintain software applications for organisations across diverse industries.",
    },
    {
      role: "Web Developer",
      area: "Digital",
      description:
        "Build responsive websites, web applications and modern digital experiences.",
    },
    {
      role: "Data Analyst",
      area: "Analytics",
      description:
        "Interpret organisational data and transform information into meaningful business insights.",
    },
    {
      role: "System Administrator",
      area: "IT Infrastructure",
      description:
        "Support, configure and maintain computer systems, networks and organisational technology environments.",
    },
    {
      role: "Database Administrator",
      area: "Data Systems",
      description:
        "Assist with the organisation, management, security and performance of database systems.",
    },
    {
      role: "Technical Support Executive",
      area: "IT Services",
      description:
        "Support users and organisations by resolving technical issues and maintaining digital systems.",
    },
  ]
};

const chapters = [
  ["overview", "Overview"], ["why", "Why ISBM"], ["highlights", "Highlights"],
  ["eligibility", "Eligibility"], ["structure", "Structure"], ["syllabus", "Syllabus"],
  ["specialisations", "Specialisations"], ["skills", "Skills"], ["outcomes", "Outcomes"],
  ["careers", "Careers"], ["placements", "Placements"], ["higher-studies", "Higher Studies"],
  ["fees", "Fees"], ["admissions", "Admissions"], ["faqs", "FAQs"], ["related", "Related Courses"],
];


const CourseDetails = () => {
  const { courseName } = useParams();

  const currentSchool = schools.find((school) =>
    school.courses?.some((course) => course.url === courseName),
  );

  const course = currentSchool?.courses?.find(
    (course) => course.url === courseName,
  );

  console.log("course: ", course);

  return (
    <>
      <MetaInfo schoolDetails="common" />

      {/* 01 — Banner | #071A2F */}
      <Header school="common" />

      <Banner course={course} images={images} school={currentSchool.title} />
      <main className="bg-white text-[#132337]">
        <div className="lg:grid lg:grid-cols-[230px_1fr]">

          {/* 00 — Sidebar Sticky | #071A2F */}
          <aside className="sticky top-0 z-30 hidden h-screen overflow-y-auto bg-[#071A2F] px-5 py-8 text-white lg:block">
            <Title light>Navigate</Title>
            <nav className="mt-7 space-y-1">
              {chapters.map(([id, label], i) =>
                <a href={`#${id}`} key={id} className="group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-white/55 transition hover:bg-white/10 hover:text-white">
                  <span className="text-[#D5AD57]">{String(i + 1).padStart(2, "0")}</span>{label}
                </a>
              )}
            </nav>
          </aside>

          <div className="">
            {/* 02 — Overview | White */}
            <Overview description={course.description} title={course.short_title ? course.short_title : course.title} images={images} />
            {/* 03 — Why choose | Ivory */}
            {course.reasons?.length > 0 && (
              <WhyChoose reasons={course.reasons} title={course.short_title ? course.short_title : course.title} images={images} />
            )}
            {/* 04 — Highlights | Navy */}
            {course.highlights?.length > 0 && (
              <Highlights highlights={course.highlights} images={images} />
            )}
            {/* 05 — Eligibility | White */}
            {course.eligibility?.length > 0 && (
              <Eligibility eligibility={course.eligibilityCriteria ? course.eligibilityCriteria : course.eligibility} title={course.short_title ? course.short_title : course.title} images={images} />
            )}
            {/*06 — Structure | Light blue */}
            {course.programStructure?.length > 0 && (
              <Structure programStructure={course.programStructure} title={course.short_title ? course.short_title : course.title} />
            )}
            {/*07 — Subjects | Ivory */}
            {course.curriculum?.length > 0 && (
              <Subjects curriculum={course.curriculum} />
            )}
            {/*08 — Specialisations | Light burgundy */}
            {course.reasons?.length > 0 && (
              <Specialisations course={demoCourse} />
            )}
            {/*09 — Skills | Soft blush */}
            {course.reasons?.length > 0 && (
              <Skills course={demoCourse} />
            )}
            {/*10 — Outcomes | Burgundy */}
            {course.reasons?.length > 0 && (
              <Outcomes course={demoCourse} />
            )}
            {/*11 — Careers | White */}
            {course.reasons?.length > 0 && (
              <Careers course={demoCourse} />
            )}
            {/*12 — Placement | Navy */}
            {course.reasons?.length > 0 && (
              <Placement course={demoCourse} />
            )}
            {/*13 — Higher studies | Light blue */}
            {course.reasons?.length > 0 && (
              <HigherStudies course={demoCourse} />
            )}
            {/*14 — Fees | Ivory */}
            {course.reasons?.length > 0 && (
              <Fees course={demoCourse} />
            )}
            {/*15 — Admission Process | White */}
            {course.reasons?.length > 0 && (
              <AdmissionProcess course={demoCourse} />
            )}
            {/*16 — FAQs | Light burgundy */}
            {course.reasons?.length > 0 && (
              <Faqs course={demoCourse} />
            )}
            {/*17 — Related | Navy */}
            {course.reasons?.length > 0 && (
              <RelatedPrograms course={demoCourse} />
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default CourseDetails;
